import { render } from "./PayrunPeriodWizard.vue?vue&type=template&id=35cef66a"
import script from "./PayrunPeriodWizard.vue?vue&type=script&lang=js"
export * from "./PayrunPeriodWizard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__